import React, { useEffect, useState } from "react";
import { AiFillStar, AiOutlineStar } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { fetchProdRating } from "../../apiCalls/product";
import moment from "moment";

const RatingList = ({ productId }) => {
  const dispatch = useDispatch();
  const reviewList = useSelector((state) => state.products.reviews);

  console.log(reviewList, "review list");

  useEffect(() => {
    fetchProdRating(dispatch, productId);
  }, [dispatch]);

  return (
    <>
      {reviewList?.map((item, index) => {
        return (
          <>
            <div className="rating-list">
              <div className="rating-list-avtar">
                {/* <img
                  src="https://loopinfosol.in/themeforest/ekka-html-v32/ekka-html/assets/images/review-image/1.jpg"
                  alt=""
                  className="img-fluid"
                /> */}
                <div className="review-avatar">
                  <p className="avatar-name">{item?.fullname?.slice(0, 1)}</p>
                </div>
              </div>
              <div className="rating-list--content">
                <div className="review-top">
                  <div className="rating-list-name">{item?.fullname}</div>
                  <div className="rating-list-stars">
                    {item?.rating === "1" && (
                      <>
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiOutlineStar className="review-list-icon" />
                        <AiOutlineStar className="review-list-icon" />
                        <AiOutlineStar className="review-list-icon" />
                        <AiOutlineStar className="review-list-icon" />
                      </>
                    )}
                    {item?.rating === "2" && (
                      <>
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiOutlineStar className="review-list-icon" />
                        <AiOutlineStar className="review-list-icon" />
                        <AiOutlineStar className="review-list-icon" />
                      </>
                    )}
                    {item?.rating === "3" && (
                      <>
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiOutlineStar className="review-list-icon" />
                        <AiOutlineStar className="review-list-icon" />
                      </>
                    )}
                    {item?.rating === "4" && (
                      <>
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiOutlineStar className="review-list-icon" />
                      </>
                    )}
                    {item?.rating === "5" && (
                      <>
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                        <AiFillStar className="review-list-icon filled-icon" />
                      </>
                    )}
                  </div>
                </div>
                <div className="review-middle">
                  <p className="review-date">
                    {moment(item?.createdAt).format("LL")}
                  </p>
                </div>
                <div className="rating-list-message">
                  <p>{item?.reviewMessage}</p>
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};

export default RatingList;
